<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/recordings">Recordings</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message v-if="recording.deleted_at" class="mb-6" @restore="restore"> This recording has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
          <select-input v-model="form.stream_id" :error="form.errors.stream_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Stream">
            <option :value="null" />
            <option v-for="stream in streams" :key="stream.id" :value="stream.id">{{ stream.name }}</option>
          </select-input>
          <hr />
          <video controls>
            <source :src="recording.url" type="video/mp4" />
          </video>
          <a class="mt-4 mb-6" :href="recording.url" target="_blank">{{ recording.url }}</a>
        </div>

        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!recording.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete recording</button>
          <div class="ml-auto flex items-center bg-gray-50 border-t border-gray-100">
            <Link class="text-blue-600 hover:underline mr-2" tabindex="-1" href="/recordings">Go back</Link>
            <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update recording</loading-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    SelectInput,
    Head,
    Link,
    LoadingButton,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    recording: Object,
    streams: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.recording.name,
        stream_id: this.recording.stream_id,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/recordings/${this.recording.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this recordings with comments?')) {
        this.$inertia.delete(`/recordings/${this.recording.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this recordings?')) {
        this.$inertia.put(`/recordings/${this.recording.id}/restore`)
      }
    },
  },
}
</script>
